<template>
    <v-row>
        <v-col cols="3">
            <v-select
                dense
                v-model="store.formInfo.format"
                :items='formats'
                item-value='id'
                item-text='value'
                :label='$t("format")'
            ></v-select>
        </v-col>
        <v-col cols="3">
            <v-text-field class="hsbcfield" v-model="store.formInfo.accountNo" :label="$t('account')" required @blur="store.updateSettings()">
            </v-text-field>
        </v-col>
        <v-col cols="3">
            <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
                :nudge-top="21"
                :nudge-right="32"
            >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field class="hsbcfield" readonly v-bind="attrs" v-on="on" :value="store.formInfo.date" :label="$t('settlementDate')" @blur="store.updateSettings()">
                </v-text-field>
            </template>
            <v-date-picker v-model="store.formInfo.date" no-title @input="menu = false"></v-date-picker>
            </v-menu>
        </v-col>
    </v-row>
</template>

<script>
export default {
    inject: ['store'],
    data() {
        return {
            bank: 'bnu',
            menu: false,
        }
    },
    created() {
        this.store.formInfo.format = this.formats[0].id
        if(!this.store.formInfo.accountNo)
            this.$set(this.store.formInfo, 'accountNo', '')
        if(!this.store.formInfo.date)
            this.$set(this.store.formInfo, 'date', (new Date()).toISOString().substring(0, 10))
    },
    computed: {
        formats() {
            return [
                {
                    id: 'txt',
                    value: 'TXT'
                },
            ]
        },
    },
    methods:{

    },

}
</script>
<style>
    .hsbcfield{
        font-size: 14px;
        padding: 0px;
    }
    .hsbcfield input{
        padding:3px 0px;
    }
    .hsbcfield .v-label{
        font-size: 14px !important;
    }
    .hsbcfield .v-label--active{
        font-size: 16px !important;
    }
</style>